module.exports = __webpack_public_path__ + "static/media/christoph-klocker.e88780e1.jpg";